import { NETWORK_BASE_URL, NETWORK_KEY } from '../constants'
import { mapStopIdToDummyStop } from './mappers'

export async function getMultipleLineDirections(lineDirectionIds, date) {
  if (lineDirectionIds.length === 0) {
    return []
  }
  let url = `${NETWORK_BASE_URL}/linedirections?ids=${lineDirectionIds.join(
    ',',
  )}`
  if (date) {
    url += `&date=${date}`
  }
  const result = await fetch(url, {
    headers: {
      'Ocp-Apim-Subscription-Key': NETWORK_KEY,
    },
  }).then((data) => data.json())
  return result.data
}

/**
 * Retrieves information for multiple stops.
 * @param {string[]} stopIds - An array of stop IDs. Must not be empty.
 * @returns {Promise<NetworkStop[]>} A Promise that resolves to the fetch multiple Stop objects.
 * If an error occurs during the fetch, it returns an array of stop information objects.
 * Each object contains a short description and a long description, both using the stop ID.
 */
export async function getMultipleStops(stopIds = []) {
  if (!stopIds.length) {
    return stopIds
  }
  const url = `${NETWORK_BASE_URL}/stops?ids=${stopIds.join(',')}`
  try {
    const { data: stops } = await (
      await fetch(url, {
        headers: {
          'Ocp-Apim-Subscription-Key': NETWORK_KEY,
        },
      })
    ).json()
    if (stops.length !== stopIds.length) {
      return stopIds.map((stopId) => {
        const foundStop = stops.find((stop) => stop.id === stopId)
        return foundStop || mapStopIdToDummyStop(stopId)
      })
    }
    return stops
  } catch (error) {
    return stopIds.map(mapStopIdToDummyStop)
  }
}

export default {
  getMultipleLineDirections,
  getMultipleStops,
}
